const styles = theme => ({
  root: {
    width: "100%",
    paddingRight: "0px !important",
    [theme.breakpoints.up("md")]: {
      alignItems: "center"
    }
  },
  regular: {
    [theme.breakpoints.down("xs")]: {
      minHeight: 48
    }
  },
  title: {
    textDecoration: "none",
    color: "black",
    textTransform: "capitalize",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flex: 1
    },
    "&>h1": {
      [theme.breakpoints.down("xs")]: {
        fontSize: "1.2rem"
      }
    }
  },
  logo: {
    height: 32,
    width: 32,
    marginRight: 16,
    [theme.breakpoints.down("xs")]: {
      height: 24,
      width: 24,
      marginRight: 8
    }
  },
  toolbar: {
    [theme.breakpoints.up("md")]: {
      width: "960px"
    }
  },
  gutters: {
    [theme.breakpoints.up("sm")]: {
      paddingRight: 8
    }
  },
  menuButton: {
    marginRight: -12
  },
  navItemsContainer: {
    textAlign: "right",
    [theme.breakpoints.up("xs")]: {
      flex: 1
    }
  },
  drawer: {
    minWidth: "60%"
  },
  drawerItemsContainer: {
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
    padding: [[16, 0]],
    "&>*": {
      padding: [[8, 24]]
    },
    "&>hr": {
      padding: 0
    },
    "&>$item": {
      fontSize: "1rem",
      marginLeft: 0,
      marginBottom: 16
    }
  },
  item: {
    cursor: "pointer",
    marginLeft: 32,
    textDecoration: "none",
    textTransform: "capitalize",
    fontWeight: 500,
    color: "rgba(0,0,0,0.7)",
    transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1)"
  },
  hover: {
    "&:hover": {
      color: "rgba(0,0,0,0.87)"
    }
  },
  btnItem: {
    color: "#2296f3",
    fontSize: "1rem",
    padding: [[8, 20]],
    minWidth: "initial"
  },
  contact: {
    marginTop: 16,
    marginBottom: 0
  },
  icon: {
    width: "1rem",
    marginRight: 8,
    marginBottom: -2
  },
  progressContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%"
  },
  progressColorPrimary: {
    background: "none"
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/TitleBar/styles.js